import React, { useCallback, useEffect, useState } from 'react';
import { PLATFORM_CONTENT_SCOPE_KEY } from '../../constants/platformContentScope';
import { listSchoolNoticesForLoginPopup } from '../../services/schoolNoticeService';
import type { SchoolNoticeRow } from '../../types/schoolNotice';
import {
  getSchoolNoticeAckUpdatedAt,
  isSchoolNoticeHiddenToday,
  setSchoolNoticeAck,
  setSchoolNoticeHideToday,
} from '../../utils/schoolNoticeSeenStorage';
import SchoolNoticeViewModal from './SchoolNoticeViewModal';

/** 로그인·워크스페이스 로드 후, 플랫폼 전역 «적용 중» 공지(최신 1건) 표시.
 *  로그인(SIGNED_IN)마다 확인(ack) 기록이 초기화되어 다시 모달이 뜬다.
 *  「오늘 보이지 않기」는 당일 재로드·재로그인에도 숨긴다. */
const LoginSchoolNoticeGate: React.FC = () => {
  const [queue, setQueue] = useState<SchoolNoticeRow[]>([]);
  const [loading, setLoading] = useState(true);
  const current = queue[0] ?? null;

  const buildQueue = useCallback(async () => {
    setLoading(true);
    try {
      const rows = await listSchoolNoticesForLoginPopup();
      const unseen = rows.filter((r) => {
        if (isSchoolNoticeHiddenToday(PLATFORM_CONTENT_SCOPE_KEY, r.id)) return false;
        return getSchoolNoticeAckUpdatedAt(PLATFORM_CONTENT_SCOPE_KEY, r.id) !== r.updated_at;
      });
      setQueue(unseen);
    } catch {
      setQueue([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void buildQueue();
  }, [buildQueue]);

  const onConfirm = () => {
    if (!current) return;
    setSchoolNoticeAck(PLATFORM_CONTENT_SCOPE_KEY, current.id, current.updated_at);
    setQueue((q) => q.slice(1));
  };

  const onHideToday = () => {
    if (!current) return;
    setSchoolNoticeHideToday(PLATFORM_CONTENT_SCOPE_KEY, current.id);
    setQueue((q) => q.slice(1));
  };

  if (loading || !current) return null;

  return (
    <SchoolNoticeViewModal
      title={current.title}
      bodyHtml={current.body_html}
      onClose={onConfirm}
      onHideToday={onHideToday}
      dismissOnBackdrop={false}
    />
  );
};

export default LoginSchoolNoticeGate;
